import { Container, HTMLChakraProps } from '@chakra-ui/react';
import { FC } from 'react';

import { Section } from '@/components/ui/core/Section/Section';
import { LectureMedia } from '@/components/ui/features/lecture/LectureHeaderSection/LectureMedia';
import { LectureOmnisearch } from '@/components/ui/features/lecture/LectureOmnisearch/LectureOmnisearch';
import { SearchInput as SharedSearchInput } from '@/components/ui/shared/inputs/SearchInput/SearchInput';

import { sectionStyles } from './LectureHeaderSection.styles';

type ILectureHeaderSectionProps = HTMLChakraProps<'div'>;

export const LectureHeaderSection: FC<ILectureHeaderSectionProps> = (props) => {
  return (
    <Section variant="dark" {...sectionStyles} {...props}>
      <Container position="relative">
        <LectureOmnisearch />
        <LectureMedia />
      </Container>
    </Section>
  );
};
